import React, { useRef } from "react"
import PropTypes from "prop-types"
import {
  Button,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
  Label,
  Input,
} from "ksc-portal-common-components/shadcn"
import PasswordInput from "../../components/PasswordInput"
import { LOGIN_TITLE } from "../constants"

const HUBLogin = ({
  errorMessage,
  renderForgottenPassword,
  searchObject,
  doLogin,
  submitButtonDisabled,
}) => {
  const emailRef = useRef<HTMLInputElement>(null)
  const passwordRef = useRef<HTMLInputElement>(null)

  return (
    <>
      <CardHeader>
        <CardTitle className="text-2xl font-medium text-foreground">
          Welcome to{" "}
          {document.title === "Kaizen Hub" ? "the Hub" : document.title}
        </CardTitle>
        <CardDescription>{LOGIN_TITLE}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <form
          onSubmit={(e) => {
            e.preventDefault()
            doLogin({
              email: emailRef.current?.value,
              password: passwordRef.current?.value,
            })
          }}
        >
          <div className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email">Email Address</Label>
              <Input
                ref={emailRef}
                id="email"
                type="email"
                placeholder="m@example.com"
                defaultValue={searchObject.username}
                required
                className={`${errorMessage ? "border-destructive" : ""}`}
                data-testid="email-input"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Password</Label>
              <PasswordInput
                ref={passwordRef}
                id="password"
                required
                className={`${errorMessage ? "border-destructive" : ""}`}
                data-testid="password-input"
              />
            </div>
          </div>
          <Button
            type="button"
            size="1"
            variant="link"
            className="text-sm text-center hover:underline p-0 text-muted-foreground my-2"
            onClick={renderForgottenPassword}
            data-testid="forgot-password-link"
          >
            Forgot password?
          </Button>
          <Button
            type="submit"
            className="w-full mt-4"
            disabled={submitButtonDisabled}
            data-testid="submit-button"
          >
            Login
          </Button>
        </form>
      </CardContent>
    </>
  )
}

HUBLogin.propTypes = {
  doLogin: PropTypes.func.isRequired,
  renderForgottenPassword: PropTypes.func.isRequired,
  searchObject: PropTypes.shape({
    username: PropTypes.string,
  }).isRequired,
  errorMessage: PropTypes.string,
  submitButtonDisabled: PropTypes.bool,
}

HUBLogin.defaultProps = {
  errorMessage: null,
  submitButtonDisabled: false,
}

export default HUBLogin
